import React from 'react';
import { Check } from '@phosphor-icons/react';

/** Selection surfaces shared by onboarding and settings. Cards and chips, never dropdowns. */

export const ChoiceCard = ({ selected, onClick, title, subtitle, icon: Icon, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`group relative text-left rounded-3xl border p-6 md:p-7 transition-all duration-300 ${
      selected
        ? 'border-primary bg-primary/[0.04] shadow-[0_0_0_1px_rgb(var(--primary))]'
        : 'border-black/[0.08] bg-white hover:border-black/20 hover:-translate-y-0.5'
    }`}
  >
    {Icon && (
      <Icon
        size={28}
        weight={selected ? 'fill' : 'regular'}
        className={`mb-4 transition-colors ${selected ? 'text-primary' : 'text-foreground-muted'}`}
      />
    )}
    <p className="font-semibold">{title}</p>
    {subtitle && <p className="text-sm text-foreground-muted mt-1">{subtitle}</p>}
    <span
      className={`absolute top-5 right-5 h-5 w-5 rounded-full flex items-center justify-center transition-all ${
        selected ? 'bg-primary scale-100' : 'scale-0'
      }`}
    >
      <Check size={12} weight="bold" className="text-white" />
    </span>
  </button>
);

export const Chip = ({ selected, onClick, children, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`px-4 h-10 rounded-full text-sm transition-all duration-200 ${
      selected
        ? 'bg-[rgb(var(--foreground))] text-white'
        : 'bg-white border border-black/[0.08] text-foreground-muted hover:border-black/25'
    }`}
  >
    {children}
  </button>
);

export const Field = ({ label, optional, children, htmlFor }) => (
  <div>
    <label htmlFor={htmlFor} className="flex items-baseline gap-2 mb-1.5">
      <span className="text-sm font-medium">{label}</span>
      {optional && <span className="text-xs text-foreground-muted">Optional</span>}
    </label>
    {children}
  </div>
);

export const inputClass =
  'w-full h-12 px-4 rounded-xl bg-[rgb(var(--background))] border border-black/[0.08] text-[15px] ' +
  'focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-colors';
